import type {ApprovalInfo} from '../../../services/rest'

export function checkIfUserCanViewApprovalInfo(approvalInfo?: ApprovalInfo | null | undefined) {
  return (
    approvalInfo?.configurationValid && (approvalInfo.userApprovals || approvalInfo.groupApprovals)
  )
}
